<ws-modal-wrapper headerLabel="Processing Errors"
                  cancelLabel="Close"
                  [hideSave]="true"
                  (cancel)="close()">
    <div>
        @if (topLevelMessage) {
            <div>
                <p>{{ topLevelMessage }}</p>
                <ul class="bulk-warning-list">
                    @for (message of errors; track message) {
                        <li>{{ message }}</li>
                    }
                    @for (message of warnings; track message) {
                        <li>{{ message }}</li>
                    }
                </ul>
            </div>
        }
        @if (!topLevelMessage && warnings && warnings.length > 0) {
            <div>
                <p>{{ warningMessage }}</p>
                <ul class="bulk-warning-list">
                    @for (message of warnings; track message) {
                        <li>{{ message }}</li>
                    }
                </ul>
            </div>
        }
        @if (!topLevelMessage && errors && errors.length > 0) {
            <div>
                <p>{{ errorMessage }}</p>
                <ul class="bulk-error-list">
                    @for (message of errors; track message) {
                        <li>{{ message }}</li>
                    }
                </ul>
            </div>
        }
    </div>
</ws-modal-wrapper>

